/**
 * Optimized image component with lazy loading, async decoding,
 * and explicit dimensions to prevent layout shift (CLS).
 *
 * Usage:
 *   <OptimizedImage src="/assets/books/pattern.png" alt="Book" width={300} height={450} />
 *   <OptimizedImage src="/assets/author/banner.png" alt="Banner" priority />
 */
export default function OptimizedImage({
  src,
  alt,
  width,
  height,
  priority = false,
  className = "",
  style = {},
  ...rest
}) {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      fetchPriority={priority ? "high" : "auto"}
      className={className}
      style={style}
      {...rest}
    />
  );
}
